export const DATA_SET = 'characterEnv.DATA_SET';
